import React from 'react';
import PropTypes from 'prop-types';

function EmailIcon({ color = 'black', width = 18, height = 16, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.49935 0.5H16.4993C16.7204 0.5 16.9323 0.587797 17.0886 0.744078C17.2449 0.900358 17.3327 1.11232 17.3327 1.33333V14.6667C17.3327 14.8877 17.2449 15.0996 17.0886 15.2559C16.9323 15.4122 16.7204 15.5 16.4993 15.5H1.49935C1.27834 15.5 1.06637 15.4122 0.910093 15.2559C0.753813 15.0996 0.666016 14.8877 0.666016 14.6667V1.33333C0.666016 1.11232 0.753813 0.900358 0.910093 0.744078C1.06637 0.587797 1.27834 0.5 1.49935 0.5ZM15.666 4.03167L9.72153 9.35531C9.34389 9.69351 8.77293 9.69562 8.39279 9.36023L2.33268 4.01333V13.8333H15.666V4.03167ZM2.75852 2.16667L8.38372 7.13026C8.76381 7.46564 9.33472 7.46358 9.71238 7.12546L15.251 2.16667H2.75852Z"
        fill={color}
      />
    </svg>
  );
}

EmailIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default EmailIcon;
